import {styled} from '@core-ui/react-stitch';
const getMarginWhenSmallerThanLargeViewPort = (isSmallerThanLargeViewPort, brRedesignEnabled) => (
  isSmallerThanLargeViewPort || brRedesignEnabled ? '2rem 1rem !important' : '2rem auto !important'
);

const CategoryBreadcrumbsDivision = styled.div(props => {
  const {
    breadcrumbsStylePreference: 
    { bottomProductBreadcrumbsEnabled, isSmallerThanLargeViewPort, brRedesignEnabled },
  } = props;

  return {
      paddingBottom: '0',
      textAlign: 'center',
      '@media (min-width: 1024px)': {
        paddingBottom: '1rem',
        paddingLeft: '1rem',
        display: 'flex',
        width: '100%',
        maxWidth: '1280px',
        justifyContent: 'center',
        margin: '0 auto',
        '& .product-breadcrumb': {
          width: '100%',
          maxWidth: '1034px', // keeps the breadcrumb aligned with lhf
          textAlign: 'left',
        },
      },
      '@media (min-width: 1280px)': {
        width: '100%',
        '& .product-breadcrumb': {
          maxWidth:'1250px', // keeps the breadcrumb aligned with lhf
        },
      },
      ...bottomProductBreadcrumbsEnabled ? {
        margin: getMarginWhenSmallerThanLargeViewPort(isSmallerThanLargeViewPort, brRedesignEnabled),
        padding: '0 !important',
        maxWidth: '800px !important',
        textAlign: 'left !important',
    }:{
      paddingTop: '0.75rem',
    },
  }
});

export default CategoryBreadcrumbsDivision;
